const DAYS = 86400
const WEEKS = 7*DAYS
const MONTHS = 30*DAYS

const pauseDurations = [
    1*DAYS,
    3*DAYS,
    1*WEEKS,
    2*WEEKS,
    3*WEEKS,
    1*MONTHS,
    2*MONTHS,
    3*MONTHS,
    6*MONTHS,
    12*MONTHS,
    Infinity
]

function getDurationInWords(s: number) {
    if(s === Infinity) return 'dauerhaft'
    const days = Math.round(s/DAYS)
    if(days%7 == 0 && days < 60) {
        const weeks = days/7
        return `${weeks} Woche${weeks == 1 ? '' : 'n'}`
    }    
    if(days < 29) return `${days} Tag${days === 1 ? '' : 'e'}`
    const months = Math.round(days/30)
    if(months == 12) return '1 Jahr'
    return `${months} Monat${months === 1 ? '' : 'e'}`

}

export default function getPauseOptions() {
    const o = pauseDurations.map(p => {
        return {
            label: getDurationInWords(p),
            value: p
        }
    })
    return [{
        label: 'nicht pausieren',
        value: 0
    }].concat(o)
}